export default __webpack_public_path__ + "static/media/14219 - RUNJ.8ab140bf.jpeg";